import { CountUp } from 'countup.js';

import '../sass/media-text-and-stats-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#blenheim-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.media-text-and-stats-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $content = $block.querySelector('.media-text-and-stats-carousel__content');
        const $navigationPrev = $block.querySelector('.media-text-and-stats-carousel__navigation-btn--prev');
        const $navigationNext = $block.querySelector('.media-text-and-stats-carousel__navigation-btn--next');
        const $carouselPagination = $block.querySelector('.media-text-and-stats-carousel__pagination');
        const $carousel = $block.querySelector('.media-text-and-stats-carousel__carousel');
        const $statCards = $block.querySelectorAll('.media-text-and-stats-carousel__slide-stat-card');
        
        const initCards = () => {
            if (!$content || !$statCards) return;

            let counters = [];

            $statCards.forEach($card => {
                const $numbers = $card.querySelectorAll('.media-text-and-stats-carousel__card-stat-number');

                if ($numbers) {
                    $numbers.forEach($number => {
                        const countUp = new CountUp($number);

                        counters.push(countUp);
                    })
                }
            });

            $content.addEventListener('onScreen', () => {
                counters.forEach(counter => {
                    counter.start();
                });
            });
        };

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                pagination: {
                    el: $carouselPagination,
                    clickable: true,
                },
                navigation: {
                    prevEl: $navigationPrev,
                    nextEl: $navigationNext,
                },
                loop: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                }
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#blenheim-schools-swiper-js');

                if (!swiperScript) return;

                initCarousel();
            });
        }

        initCards();
    });
})();
